



































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";

import AddChannelFormStream from "@/components/forms/channels/add-channel-form-stream.vue";
import ChannelTypeDropdown from "@/components/app/dropdowns/channels/channel-type-dropdown.vue";
import AddChannelFormIP from "@/components/forms/channels/add-channel-form-IP.vue";
import AddChannelFormDVBT from "@/components/forms/channels/add-channel-form-DVB-T.vue";
import AddChannelFormDVBS from "@/components/forms/channels/add-channel-form-DVB-S.vue";
import AddChannelFromPRO from "@/components/forms/channels/add-channel-form-PRO.vue";
import ChannelsDemo from "../../../components/demo/channels/channels-demo.vue";
import MainDemo from "@/components/demo/main-demo.vue";
import UploadingImageToServer from "@/components/app/images/uploading-image-to-server.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import {
  broadcastTypes,
  rfBroadcastTypes,
} from "@/config/channels/channel-types.config.json";

@Component({
  components: {
    StandartModal,
    AddChannelFormStream,
    ChannelTypeDropdown,
    AddChannelFormIP,
    AddChannelFormDVBT,
    AddChannelFormDVBS,
    "add-channel-form-PRO": AddChannelFromPRO,
    ChannelsDemo,
    MainDemo,
    UploadingImageToServer,
  },
})
export default class ChangeChannelModal extends Vue {
  @Prop({ type: Object, default: null }) item!: IChannel | null;
  @Prop({ type: String, default: "tv" }) activeType!: string;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;

  changing_form_type = broadcastTypes[3];

  demoName = this.item ? this.item.name : "";
  demoImg = this.item ? this.item.image : "";

  get channelForm(): string {
    if (this.changing_form_type == "PRO") return "PRO";
    if (this.activeType == "stream") return "stream";

    const arr = this.changing_form_type.split("");
    if (arr[arr.length - 1] == "2") {
      arr.pop();
    }
    const result = arr.join("") == "DVB-C" ? "DVB-T" : arr.join("");
    return result;
  }

  hideModal(): void {
    this.$emit("close");
    this.changing_form_type = broadcastTypes[3];
  }

  triggerSubmit(): void {
    const form = this.$refs.channelForm as { onSubmit?: (e: unknown) => void };
    if (form && typeof form.onSubmit === "function") {
      form.onSubmit({ preventDefault: () => undefined });
    }
  }

  triggerReset(): void {
    const form = this.$refs.channelForm as { onReset?: () => void };
    if (form && typeof form.onReset === "function") {
      form.onReset();
    }
  }

  onImageUpdate(name: string): void {
    const form = this.$refs.channelForm as {
      posterName?: string;
      image?: string;
    };
    if (!form) return;
    if (form.posterName !== undefined) form.posterName = name;
    else if (form.image !== undefined) form.image = name;
  }

  updateDemo(name: string, img: string): void {
    this.demoName = name;
    this.demoImg = img;
  }

  @Watch("item")
  update(): void {
    this.demoName = this.item ? this.item.name : "";
    this.demoImg = this.item ? this.item.image : "";
    if (this.item && this.item.data) {
      if (
        this.item.data.channelType === 2 ||
        this.item.data.channelType === 4
      ) {
        this.changing_form_type = "IP";
        return;
      }
      if (this.item.data.rfBroadcastType) {
        const rfType = rfBroadcastTypes.find(
          (rf) => rf.id === this.item!.data.rfBroadcastType
        );
        if (rfType && broadcastTypes.includes(rfType.abriviate)) {
          this.changing_form_type = rfType.abriviate;
        }
      }
    }
  }
}
